import {Component, OnInit, ViewChild, ChangeDetectorRef} from '@angular/core';
import {HeaderService} from "../../../../services/header/header.service";
import {Router} from "@angular/router";
import {SaveComponent} from "../detail-tresorerie/save/save.component";
import {AddDepenseComponent} from "./add-depense/add-depense.component";
import {AjoutSoldeComponent} from "./ajout-solde/ajout-solde.component";
import {RemiseBanqueComponent} from "./remise-banque/remise-banque.component";
import {TresorerieService} from "../../../../services/tresorerie/tresorerie.service";
import {ToastrService} from "ngx-toastr";
import {Solde} from '../../../../models/Tresorerie/Solde';

@Component({
  selector: 'app-tresorerie',
  templateUrl: './tresorerie.component.html',
  styleUrls: ['./tresorerie.component.scss']
})
export class TresorerieComponent implements OnInit {
    @ViewChild('ajoutSolde') ajoutSoldeComponent!: AjoutSoldeComponent;
    @ViewChild('addDepense') addDepenseComponent!: AddDepenseComponent;
    @ViewChild('save') saveComponent!: SaveComponent;
    @ViewChild('remiseBanque') remiseBanqueComponent!: RemiseBanqueComponent;

    warehouses: any[] = [];
    stationId: number = 0;
    userId: number = 0;
    isLoading = false;

    constructor(
        private headerService: HeaderService,
        private router: Router,
        private tresorerieService: TresorerieService,
        private toastr: ToastrService,
        private cdr: ChangeDetectorRef
    ) {}

  ngOnInit(): void {
        this.loadUserData();
      this.headerService.setConfig({
          title: 'Gestion de la trésorerie',
            buttons: [
                {
                    label: 'Ajouter',
                    action: () => this.openAjoutSoldeModal(),
                    type: 'primary'
                }
            ]
        });
    }

    private loadUserData(): void {
        try {
            const userJson = localStorage.getItem('currentUser');
            if (userJson) {
                const user = JSON.parse(userJson);
                this.userId = user?.id != null ? Number(user.id) : 0;
                const station = user?.stations?.[0];
                this.stationId = station?.id ? Number(station.id) : 0;
                if (this.stationId && this.userId) {
                    this.loadSoldes();
                }
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des données utilisateur:', error);
            this.toastr.error('Erreur lors de la récupération des données utilisateur.', 'Erreur');
  }
    }

    private loadSoldes(): void {
        if (!this.stationId || !this.userId) {
            this.warehouses = [];
            this.isLoading = false;
            this.cdr.detectChanges();
            return;
        }
        this.isLoading = true;
        this.tresorerieService.getSoldesByStationAndUser(this.stationId, this.userId).subscribe({
            next: (soldes: Solde[]) => {
                const parseMontant = (value: any): number => {
                    if (value === null || value === undefined || value === '') {
                        return 0;
                    }
                    if (typeof value === 'number') {
                        return isNaN(value) ? 0 : value;
                    }
                    if (typeof value === 'string') {
                        const parsed = parseFloat(value.replace(/[^\d.,-]/g, '').replace(',', '.'));
                        return isNaN(parsed) ? 0 : parsed;
                    }
                    return 0;
                };

                this.warehouses = (soldes || []).map((solde) => {
                    const soldeNormalise: any = {
                        ...solde,
                        montant_retenue: solde.montant_retenue ?? (solde as any).montantRetenue ?? '0',
                        montant_traites: (solde as any).montant_traites ?? solde.montant_traite ?? (solde as any).montantTraites ?? (solde as any).montantTraite ?? '0',
                        montant_cheques: (solde as any).montant_cheques ?? solde.montant_cheque ?? (solde as any).montantCheques ?? (solde as any).montantCheque ?? '0',
                        montant_espece: solde.montant_espece ?? (solde as any).montantEspece ?? '0'
                    };
                    const libelle = (solde.type_solde && String(solde.type_solde).trim()) || 'Solde';
                    const montantTotal = parseFloat(String(soldeNormalise.montant_total || '0'));
                    return {
                        name: libelle,
                        stockValue: montantTotal,
                        type_solde: solde.type_solde,
                        id: solde.id,
                        retenue: parseMontant(soldeNormalise.montant_retenue),
                        traites: parseMontant(soldeNormalise.montant_traites ?? soldeNormalise.montant_traite),
                        cheques: parseMontant(soldeNormalise.montant_cheques ?? soldeNormalise.montant_cheque),
                        espece: parseMontant(soldeNormalise.montant_espece)
                    };
                });
                this.cdr.detectChanges();
                this.isLoading = false;
            },
            error: (error) => {
                console.error('Erreur lors du chargement des soldes:', error);
                this.toastr.error('Erreur lors du chargement des soldes.', 'Erreur');
                this.warehouses = [];
                this.cdr.detectChanges();
                this.isLoading = false;
            }
        });
    }


    detailTresorerie(typeSolde?: 'primaire' | 'secondaire') {
        const queryParams = typeSolde ? { type: typeSolde } : {};
        this.router.navigate(['/comptabilite/tresorerie/detail'], { queryParams });
    }
    openAjoutSoldeModal(): void {
        this.ajoutSoldeComponent.openModal();
    }

    openAddModal(typeSolde?: string) {
        this.addDepenseComponent.soldeType = typeSolde || 'secondaire';
        this.addDepenseComponent.openModal();
    }

    onSoldeCreated(): void {
        setTimeout(() => {
            this.loadSoldes();
        }, 500);
    }

    onDepenseCreated() {
        setTimeout(() => {
            console.log('🔄 [TresorerieComponent] Rechargement des soldes après création de dépense...');
            this.loadSoldes();
        }, 500);
    }
    openRemiseBanqueModal(typeSolde?: string) {
        this.remiseBanqueComponent.soldeType = typeSolde || 'secondaire';
        this.remiseBanqueComponent.openModal();
    }

    onRemiseCreated() {
        setTimeout(() => {
            console.log('🔄 [TresorerieComponent] Rechargement des soldes après création de remise...');
            this.loadSoldes();
        }, 500);
    }

    formatMontant(montant: number | null | undefined): string {
        if (montant === null || montant === undefined || isNaN(montant)) {
            return '0,000 TND';
        }
        const montantNum = typeof montant === 'number' ? montant : parseFloat(String(montant));
        if (isNaN(montantNum)) {
            return '0,000 TND';
        }
        return montantNum.toLocaleString('fr-FR', {minimumFractionDigits: 3, maximumFractionDigits: 3}) + ' TND';
    }
    openSaveModal(typeSolde?: string) {
        this.saveComponent.soldeType = typeSolde || 'secondaire';
        this.saveComponent.openModal();
    }


}
